import { select, takeEvery } from 'redux-saga/effects';
import { getServiceProvider, IServiceProvider } from '../../../services';
import selectors from '../selectors';
import { commonActions } from '../../common';
import { PayloadMetaAction, TypeConstant } from '../../../utils/reduxUtils';

const clearAssetCacheSaga = takeEvery([commonActions.clearAssetCache.type], function* (
  action: PayloadMetaAction<TypeConstant, string, void>
) {
  const serviceProvider: IServiceProvider = yield getServiceProvider();

  if (serviceProvider.cacheService.supportsCache()) {
    try {
      const state = yield select();
      const imageUrls = selectors.selectAllTourImages(state, { tour: action.payload });
      const audioUrls = selectors.selectAllAudioUrls(state, { tour: action.payload });
      yield serviceProvider.cacheService.removeFromCache('image-cache', imageUrls);
      yield serviceProvider.cacheService.removeFromCache('audio-cache', audioUrls);
    } catch (e) {
      console.error(e);
      serviceProvider.analyticsService.logError(e);
    }
  }
});

const sagas = [clearAssetCacheSaga];

export default sagas;
